import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Paginacion } from './Paginacion';
import { ProfesoresConsulta } from './ProfesoresConsulta';

const TITLE = "Reportes de Retroalimentación Estudiantil";
const APIURL = process.env.REACT_APP_API_URL;

export class Profesores extends Component {
    static displayName = Profesores.name;

    constructor(props) {
        super(props);
        this.state = { profesores: [], page: 1, size: 10, apellidos: "", nombres: "", loading: true };
        this.handlePage = this.handlePage.bind(this);
    }

    componentDidMount() {
        document.title = TITLE + " - Histórico por profesor";
        const page = parseInt(this.props.match.params["page"]) || this.state.page || 1;
        const size = parseInt(this.props.match.params["size"]) || this.state.size || 10;
        const apellidos = this.props.match.params["search1"] || this.state.apellidos || "";
        const nombres = this.props.match.params["search2"] || this.state.nombres || "";
        //console.log("page = " + page + " size = " + size + " apellidos = " + apellidos + " nombres = " + nombres);
        if (this.state.loading) {
            this.populateData(page, size, apellidos.trim(), nombres.trim());
        }
    }

    componentDidUpdate() {
        const page = parseInt(this.props.match.params["page"]) || this.state.page || 1;
        const size = parseInt(this.props.match.params["size"]) || this.state.size || 10;
        const apellidos = this.props.match.params["search1"] || this.state.apellidos || " ";
        const nombres = this.props.match.params["search2"] || this.state.nombres || " ";
        //console.log("page = " + page + " size = " + size + " apellidos = " + apellidos + " nombres = " + nombres);
        if (this.state.loading) {
            this.populateData(page, size, apellidos, nombres);
        }
    }

    handlePage(url, page, size, apellidos, nombres) {

        let newUrl = `${url}/${page}/${size}`;

        if (apellidos && apellidos.trim() !== "") {
            newUrl += `/${encodeURIComponent(apellidos.trim())}`;
        }
        if (nombres && nombres.trim() !== "") {
            if (!apellidos || apellidos.trim() === "") newUrl += `/${encodeURIComponent(" ")}`;
            newUrl += `/${encodeURIComponent(nombres.trim())}`;
        }

        this.props.history.push(newUrl);
        this.setState({ loading: true, page: page, size: size, apellidos: apellidos, nombres: nombres });
    }

    renderTable(profesores) {
        return (
            <table className='table table-striped' aria-labelledby="tabelLabel">
                <thead>
                    <tr>
                        <th>Apellidos</th>
                        <th>Nombres</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {profesores.map(profesor =>
                        <tr key={profesor.identificacion}>
                            <td>{profesor.apellidos}</td>
                            <td>{profesor.nombres}</td>
                            <td>
                                <Link className="btn btn-secondary" to={`/paralelos-profesor/${profesor.identificacion}`}>Detalle</Link>
                            </td>
                        </tr>
                    )}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan={3}>
                            <Paginacion total={this.state.total} page={this.state.page} size={this.state.size} search1={this.state.apellidos} search2={this.state.nombres} url={`/profesores`} handle={this.handlePage} />
                        </td>
                    </tr>
                </tfoot>
            </table>
        );
    }

    render() {
        const page = parseInt(this.props.match.params["page"]) || this.state.page || 1;
        const size = parseInt(this.props.match.params["size"]) || this.state.size || 10;
        const apellidos = this.props.match.params["search1"] || this.state.apellidos || "";
        const nombres = this.props.match.params["search2"] || this.state.nombres || "";

        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderTable(this.state.profesores);

        return (
            <div>
                <h1 id="tabelLabel" >Histórico por Profesores</h1>
                <br />
                <ProfesoresConsulta apellidos={apellidos} nombres={nombres} page={1} size={10} url={`/profesores`} handle={this.handlePage} />
                <br />
                {contents}
            </div>
        );
    }

    async populateData(page, size, apellidos, nombres) {
        let apiUrl = `${APIURL}/api/reportes/profesores/${page}/${size}`;

        if (apellidos && apellidos.trim() !== "") {
            apiUrl += `/${encodeURIComponent(apellidos.trim())}`;
        }
        if (nombres && nombres.trim() !== "") {
            if (!apellidos || apellidos.trim() === "") apiUrl += `/${encodeURIComponent(" ")}`;
            apiUrl += `/${encodeURIComponent(nombres.trim())}`;
        }

        const response = await fetch(apiUrl);
        const data = await response.json();
        this.setState({ total: data.total, profesores: data.datos, page: page, size: size, apellidos: apellidos, nombres: nombres, loading: false });
    }
}
